<script>
import TransitionExpand from '@/components/shared/TransitionExpand.vue';
import MenuItemAnchorLinks from './MenuItemAnchorLinks.vue';
import MenuItemExternal from './MenuItemExternal.vue';

export default {
  name: 'MenuItemApiReference',

  components: {
    TransitionExpand,
    MenuItemAnchorLinks,
    MenuItemExternal,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    slug() {
      return this.pageLink && this.pageLink.fields ? this.pageLink.fields.slug : '';
    },

    externalLink() {
      return this.item.fields.link.fields && this.item.fields.link.fields.url;
    },

    pageLink() {
      return this.item.fields.link.fields && this.item.fields.link.fields.slug
        ? this.item.fields.link
        : undefined;
    },

    path() {
      return `/api/${this.slug}`;
    },

    urlItems() {
      return this.$route.path.replace('/', '').split('/');
    },

    isActive() {
      return this.pageLink ? this.urlItems[1] === this.slug : false;
    },

    showAnchorLinks() {
      const { pageLink, isActive } = this;
      return !!(pageLink && pageLink.fields && pageLink.fields.versions && isActive);
    },
  },
};
</script>

<template>
  <div>
    <MenuItemExternal v-if="externalLink" :item="item" :level="0" />

    <template v-else>
      <router-link :to="path" class="level-1" :class="{ active: isActive }">
        {{ item.fields.heading }}
      </router-link>
    </template>

    <TransitionExpand>
      <MenuItemAnchorLinks v-if="showAnchorLinks" :page="pageLink" />
    </TransitionExpand>
  </div>
</template>

<style lang="scss" scoped>
.level-1 {
  @include menu-item-level-0;

  &.active {
    color: $interaction-color-primary;
  }
}
</style>
